<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="500" persistent>
      <v-card>
        <v-card-text class="text-center">
          <v-form ref="forms">
            <div v-if="!isAllBranch">
              <img
                height="100"
                width="100"
                :src="require('@/assets/bell.gif')"
                class="mt-6"
              />
              <br />
              <h1>{{ $t("package.swal.title") }}</h1>
              <br />
              <span style="font-size: 20px; font-weight: bold"
                >{{ $t("package.swal.text_storage")
                }}<span
                  class="mx-2"
                  :style="'color:' + _pageDetailcolor + ';font-size:23px;'"
                  >{{ item.name }}</span
                ></span
              >
              <br /><br />
              <span>
                <b class="float-left">
                  {{ $t("package.swal.text_address_etax") }}</b
                >
                <v-autocomplete
                  :color="_pageDetailcolor"
                  :items="listBranch"
                  item-text="branch_name"
                  item-value="branchid"
                  v-model="sellerBranchID"
                  persistent-hint
                  outlined
                  return-object
                  dense
                  style="width: 100%"
                  :loading="isLoading"
                  class="my-input text-center"
                  :label="$t('package.swal.valid_address_etax')"
                ></v-autocomplete>
              </span>
              <div id="page_1">
                <!--@click="fn_seeMoreBranch()"-->
                <v-layout row wrap justify-center align-center mt-3 mb-3>
                  <v-flex lg10 md10 sm10 xs12>
                    <div class="d-flex row ml-5">
                      <v-icon>mdi-map-marker-radius</v-icon>
                      <div v-if="sellerBranchID">
                        <b class="ml-2"
                          >{{ $t("package.swal.text_branch") }} :</b
                        >
                        {{ sellerBranchID.branch_name }}<br />
                      </div>
                      <!--<span class="ml-2"
                        ><b>
                          {{ $t("package.swal.text_address_etax") }}
                        </b></span
                      >-->
                      <v-spacer />
                      <v-progress-circular
                        v-if="isLoading"
                        size="20"
                        indeterminate
                        color="primary"
                        class="ml-3"
                      />
                    </div>
                    <div v-if="sellerBranchID" class="text-left ml-13">
                      <!--<b class="mr-1">{{ $t("package.swal.text_branch") }} :</b>
                      {{ sellerBranchID.branch_name }}<br />-->
                      <b class="mr-1">{{ $t("package.swal.text_taxid") }} :</b>
                      {{ sellerBranchID.taxid }}
                      <br />
                      <b class="mr-2"
                        >{{ $t("package.swal.text_address") }} :</b
                      >
                      <span
                        v-if="
                          sellerBranchID.house_no != null &&
                          sellerBranchID.house_no != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_house_no") }}
                        {{ sellerBranchID.house_no }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.room_no != null &&
                          sellerBranchID.room_no != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_room_no") }}
                        {{ sellerBranchID.room_no }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.floor != null &&
                          sellerBranchID.floor != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_room_no") }}
                        {{ sellerBranchID.floor }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.building_name != null &&
                          sellerBranchID.building_name != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_building_name") }}
                        {{ sellerBranchID.building_name }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.moo_ban != null &&
                          sellerBranchID.moo_ban != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_moo_ban") }}
                        {{ sellerBranchID.moo_ban }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.moo_no != null &&
                          sellerBranchID.moo_no != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_moo_no") }}
                        {{ sellerBranchID.moo_no }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.soi != null && sellerBranchID.soi != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_soi") }}
                        {{ sellerBranchID.soi }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.yaek != null &&
                          sellerBranchID.yaek != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_yaek") }}
                        {{ sellerBranchID.yaek }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.street != null &&
                          sellerBranchID.street != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_street") }}
                        {{ sellerBranchID.street }}</span
                      >
                      <span
                        v-if="
                          sellerBranchID.zipcode_tambon != null &&
                          sellerBranchID.zipcode_tambon != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_zipcode_tambon")
                        }}{{ sellerBranchID.zipcode_tambon }},</span
                      >
                      <span
                        v-if="
                          sellerBranchID.zipcode_amphoe != null &&
                          sellerBranchID.zipcode_amphoe != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_zipcode_amphoe")
                        }}{{ sellerBranchID.zipcode_amphoe }},</span
                      >
                      <span
                        v-if="
                          sellerBranchID.zipcode_province != null &&
                          sellerBranchID.zipcode_province != ''
                        "
                        class="mr-1"
                        >{{ $t("package.swal.text_zipcode_province")
                        }}{{ sellerBranchID.zipcode_province }},</span
                      >
                      <span
                        v-if="
                          sellerBranchID.zipcode_zipcode != null &&
                          sellerBranchID.zipcode_zipcode != ''
                        "
                        class="mr-1"
                        >{{ sellerBranchID.zipcode_zipcode }}</span
                      >
                      <!--รหัสไปรษณีย์-->
                    </div>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs12>
                    <!--<v-icon style="cursor: pointer">mdi-chevron-right</v-icon>-->
                  </v-flex>
                </v-layout>
              </div>
              <br />
              <center>
                <span>
                  <b class="float-left"> {{ $t("package.swal.text_email") }}</b>
                  <v-text-field
                    v-model="email"
                    class="my-input text-center"
                    dense
                    append-icon="mdi-email"
                    hide-details="auto"
                    :rules="emailRules"
                    outlined
                    style="width: 100%"
                    :color="_pageDetailcolor"
                    :label="$t('package.swal.email')"
                    @input="fn_checkRegex()"
                    :error-messages="regex"
                    required
                  ></v-text-field>
                </span>
                <div class="mt-6">
                  <v-btn color="#f05c5a" dark @click="fn_close()">{{
                    $t("settingLogo.condition.btnCancle")
                  }}</v-btn>
                  <v-btn
                    :color="_pageDetailcolor"
                    :loading="loading"
                    class="mx-2 white--text"
                    :disabled="!email"
                    @click="fn_save()"
                  >
                    {{ $t("colorpiker.condition.btn_submit") }}
                  </v-btn>
                  <!--:disabled="!email"-->
                </div>
              </center>
            </div>
            <div v-else>
              <v-card class="elevation-0 pt-5 pb-5">
                <v-card-title>
                  <v-icon class="mr-1">mdi-map-marker-radius</v-icon
                  ><span class="text-left"
                    ><b>{{ $t("package.swal.text_all_address") }}</b></span
                  >
                  <span style="color: #2196f3" class="ml-3"
                    ><b
                      >({{ total }} {{ $t("package.swal.text_branch") }})</b
                    ></span
                  >
                  <v-spacer />
                  <v-btn
                    color="#f05c5a"
                    dark
                    class="elevation-0 text-end"
                    @click="isAllBranch = false"
                  >
                    <v-icon class="mr-1">mdi-arrow-left-circle</v-icon>
                    {{ $t("package.swal.text_back") }}
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-text-field
                      v-model="search"
                      outlined
                      clearable
                      append-icon="mdi-magnify"
                      clear-icon="mdi-close-circle"
                      :placeholder="$t('package.swal.searh_branch')"
                      type="text"
                      class="mt-5 mb-n6 text-center"
                      dense
                    />
                  </div>
                  <div class="cardBranch">
                    <div
                      id="page_2"
                      v-for="(item, index) in listBranch"
                      :key="index"
                    >
                      <v-layout
                        @click="fn_selectBranch(item)"
                        row
                        wrap
                        justify-center
                        align-center
                        mt-3
                        mb-3
                      >
                        <v-flex lg10 md10 sm10 xs12>
                          <div class="d-flex row mr-1 ml-0">
                            <b class="mr-1"
                              >{{ $t("package.swal.text_branch") }} :
                            </b>
                            {{ item.branch_name }}
                            <v-spacer></v-spacer>
                            <v-btn x-small class="btn_select elevation-0">
                              <v-icon class="mr-0" size="15"
                                >mdi-playlist-edit</v-icon
                              >
                              <b>{{ $t("package.swal.text_select") }}</b>
                            </v-btn>
                          </div>
                          <div class="text-left">
                            <b class="mr-1"
                              >{{ $t("package.swal.text_taxid") }} :</b
                            >
                            {{ item.taxid }}
                            <br />
                            <b class="mr-2"
                              >{{ $t("package.swal.text_address") }} :</b
                            >
                            <span
                              v-if="
                                item.house_no != null && item.house_no != ''
                              "
                              class="mr-1"
                              >{{ $t("package.swal.text_house_no") }}
                              {{ item.house_no }}</span
                            >
                            <span
                              v-if="item.room_no != null && item.room_no != ''"
                              class="mr-1"
                              >{{ $t("package.swal.text_room_no") }}
                              {{ item.room_no }}</span
                            >
                            <span
                              v-if="item.floor != null && item.floor != ''"
                              class="mr-1"
                              >{{ $t("package.swal.text_floor") }}
                              {{ item.floor }}</span
                            >
                            <span
                              v-if="
                                item.building_name != null &&
                                item.building_name != ''
                              "
                              class="mr-1"
                              >{{ $t("package.swal.text_building_name") }}
                              {{ item.building_name }}</span
                            >
                            <span
                              v-if="item.moo_ban != null && item.moo_ban != ''"
                              class="mr-1"
                              >{{ $t("package.swal.text_moo_ban") }}
                              {{ item.moo_ban }}</span
                            >
                            <span
                              v-if="item.moo_no != null && item.moo_no != ''"
                              class="mr-1"
                              >{{ $t("package.swal.text_moo_no") }}
                              {{ item.moo_no }}</span
                            >
                            <span
                              v-if="item.soi != null && item.soi != ''"
                              class="mr-1"
                              >{{ $t("package.swal.text_soi") }}
                              {{ item.soi }}</span
                            >
                            <span
                              v-if="item.yaek != null && item.yaek != ''"
                              class="mr-1"
                              >{{ $t("package.swal.text_yaek") }}
                              {{ item.yaek }}</span
                            >
                            <span
                              v-if="item.street != null && item.street != ''"
                              class="mr-1"
                              >{{ $t("package.swal.text_street") }}
                              {{ item.street }}</span
                            >
                            <span
                              v-if="
                                item.zipcode_tambon != null &&
                                item.zipcode_tambon != ''
                              "
                              class="mr-1"
                              >{{ $t("package.swal.text_zipcode_tambon")
                              }}{{ item.zipcode_tambon }},</span
                            >
                            <span
                              v-if="
                                item.zipcode_amphoe != null &&
                                item.zipcode_amphoe != ''
                              "
                              class="mr-1"
                              >{{ $t("package.swal.text_zipcode_amphoe")
                              }}{{ item.zipcode_amphoe }},</span
                            >
                            <span
                              v-if="
                                item.zipcode_province != null &&
                                item.zipcode_province != ''
                              "
                              class="mr-1"
                              >{{ $t("package.swal.text_zipcode_province")
                              }}{{ item.zipcode_province }},</span
                            >
                            <span
                              v-if="
                                item.zipcode_zipcode != null &&
                                item.zipcode_zipcode != ''
                              "
                              class="mr-1"
                              >{{ item.zipcode_zipcode }}</span
                            >
                          </div>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <p class="red--text pt-n4">
                <span class="pr-2">*</span
                ><b>{{ $t("package.swal.remark") }}</b>
                <a href="/portal/branch" class="ml-2">
                  <b>{{ $t("package.swal.text_menu") }}</b>
                </a>
              </p>
            </div>
          </v-form>
        </v-card-text>
        <br />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import authorization from "@/authorization/authorization.js";
import { mapGetters, mapState } from "vuex";
import etaxJson from "@/variable/etaxJson/packageText";
import { mask } from "vue-the-mask";
import getBranch from "@/functions/getBranch.js";

export default {
  directives: { mask },
  props: ["show", "item"],
  data: function () {
    return {
      mask: "##########",
      tel: "",
      email: "",
      emailRules: [
        (v) => !!v || this.$t("package.swal.enter_email"),
        (v) => /.+@.+/.test(v) || this.$t("package.swal.err_email"),
      ],
      loading: false,
      creditPerTrans: 3,
      prepaiddetail: {
        link: "",
        token: "",
      },
      regex: "",
      isLoading: true,
      listBranch: [],
      sellerBranchID: null,
      isAllBranch: false,
      search: "",
      total: 0,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.email = "";
        this.loading = false;
        this.isLoading = true;
        this.jsonSign = etaxJson;
        this.fn_listBranch();
      }
    },
    isAllBranch(val) {
      if (val === true) {
        this.search = "";
      }
    },
    search(val) {
      if (val === null || val === "") {
        val = "";
        this.fn_listBranch();
      } else {
        this.fn_searchBranch(val);
      }
    },
  },
  methods: {
    fn_searchBranch(search) {
      this.listBranch = this.listBranch.filter((e) => {
        if (
          e.branchid.indexOf(search) > -1 ||
          e.branch_name.indexOf(search) > -1
        ) {
          return e;
        }
      });
    },
    async fn_listBranch() {
      let check = await getBranch.list(this._taxId || "");
      if (check.status == "OK") {
        this.listBranch = check.message;
        this.total = this.listBranch.length;
        if (this.listBranch.length > 0) {
          //console.log("_SellerBranchId ->", this._SellerBranchId);
          this.sellerBranchID = this.listBranch.find(
            (obj) => obj.branchid === this._SellerBranchId
          );
          //this.sellerBranchID = this.listBranch[0];
        }
      }
      this.isLoading = false;
    },
    fn_checkRegex() {
      var mail = this.email.split(",");
      for (var i of mail) {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        var check = re.test(String(i).toLowerCase());
        if (check == false) {
          this.regex = this.$t("dialogEmail.regex");
        } else {
          this.regex = "";
        }
      }
    },
    async fn_save() {
      if (this.$refs.forms.validate()) {
        this.loading = true;
        var payload = {
          email: this.email,
          package_id: this.item.package_id,
          seller_id: this.item.seller_id,
          taxid: this.item.taxid,
          usercode: this.item.updated_by,
        };
        payload["etax_details"] = this.fn_setJsonSign(this.item, "package");
        var dataEncode = await authorization.encodeData(payload);
        var auth = await authorization.gentoken(this.item.taxid);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_PACKAGE_API + "users/buy-storage",
            { data: dataEncode },
            { headers }
          )
          .then((res) => {
            //console.log("res", res);
            this.loading = false;
            if (res.data.status == "OK") {
              this.prepaiddetail = res.data.data;
              // Go Payment Cashier
              this.getPayment();
            } else {
              swal({
                title: this.$t("package.swal.errorTitle"),
                text: res.data.errorMessage,
                icon: "error",
              });
            }
          })
          .catch((error) => {
            //console.log('error', error.response);
            this.loading = false;
            swal({
              title: this.$t("package.swal.errorTitle"),
              text: error.response.data.errorMessage,
              icon: "error",
            });
          });
      }
    },
    // Go Payment Cashier
    getPayment() {
      var url = this.prepaiddetail; //new
      window.location.href = url;
      this.$emit("getPackege");
    },
    fn_setJsonSign(data, type) {
      this.jsonSign.buyer_taxid = data.taxid;
      this.jsonSign.buyer_branch = this.sellerBranchID.branchid;
      this.jsonSign.buyer_name = this.sellerBranchID.business_name;
      this.jsonSign.basis_amount = data.price;
      this.jsonSign.grand_total_amount = data.price;
      this.jsonSign.lineitem[0].total_price = data.price;
      // เขียนชื่อรายการ
      if (type == "credit") {
        this.jsonSign.lineitem[0].price = this.creditPerTrans;
        this.jsonSign.lineitem[0].amount = data.purchase_credit;
      } else {
        this.jsonSign.lineitem[0].price = data.price;
      }
      this.jsonSign.lineitem[0].product_name =
        "ค่าบริการซื้อ Storage " + data.storage;
      // เพิ่มข้อมุลที่อยู่
      this.jsonSign.address.no = this.sellerBranchID.house_no || "";
      this.jsonSign.address.soi = this.sellerBranchID.soi || "";
      this.jsonSign.address.road = this.sellerBranchID.street || "";
      this.jsonSign.address.amphur = this.sellerBranchID.zipcode_amphoe || "";
      this.jsonSign.address.thambol = this.sellerBranchID.zipcode_tambon || "";
      this.jsonSign.address.village = this.sellerBranchID.moo_ban || "";
      this.jsonSign.address.building = this.sellerBranchID.building_name || "";
      this.jsonSign.address.province =
        this.sellerBranchID.zipcode_province || "";
      this.jsonSign.address.moo_number = this.sellerBranchID.moo_no || "";
      this.jsonSign.address.postal_code =
        this.sellerBranchID.zipcode_zipcode || "";
      this.jsonSign.address.room_number = this.sellerBranchID.room_no || "";
      this.jsonSign.address.floor_number = this.sellerBranchID.floors || "";
      return this.jsonSign;
    },
    fn_seeMoreBranch() {
      this.isAllBranch = true;
    },
    fn_selectBranch(data) {
      this.sellerBranchID = data;
      this.isAllBranch = false;
    },
    fn_close() {
      this.email = "";
      this.tel = "";
      this.regex = "";
      this.$refs.forms.resetValidation();
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters(["getter_dataBusiness_profile"]),
    ...mapState(["pageDetailcolor", "cardTitle"]),
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _cardTitle: {
      get() {
        return this.cardTitle;
      },
    },
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogDelete");
        }
      },
    },
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _SellerBranchId: {
      get() {
        return this.getter_dataBusiness_profile["branch_no"];
      },
    },
    _Companyname: {
      get() {
        if (this.$i18n.locale === "th") {
          return (
            this.getter_dataBusiness_profile["name_on_document_th"] ||
            this.getter_dataBusiness_profile["first_name_th"] +
              this.getter_dataBusiness_profile["last_name_th"] ||
            "-"
          );
        } else {
          return (
            this.getter_dataBusiness_profile["name_on_document_eng"] ||
            this.getter_dataBusiness_profile["first_name_eng"] +
              this.getter_dataBusiness_profile["last_name_eng"] ||
            "-"
          );
        }
      },
    },
    _HouseNo: {
      get() {
        return this.getter_dataBusiness_profile["address"]["house_no"];
      },
    },
    _RoomNo: {
      get() {
        return this.getter_dataBusiness_profile["address"]["room_no"];
      },
    },
    _Floor: {
      get() {
        return this.getter_dataBusiness_profile["address"]["floor"];
      },
    },
    _buildingName: {
      get() {
        return this.getter_dataBusiness_profile["address"]["building_name"];
      },
    },
    _mooBan: {
      get() {
        return this.getter_dataBusiness_profile["address"]["moo_ban"];
      },
    },
    _mooNo: {
      get() {
        return this.getter_dataBusiness_profile["address"]["moo_no"];
      },
    },
    _Soi: {
      get() {
        return this.getter_dataBusiness_profile["address"]["soi"];
      },
    },
    _Yaek: {
      get() {
        return this.getter_dataBusiness_profile["address"]["yaek"];
      },
    },

    _Street: {
      get() {
        return this.getter_dataBusiness_profile["address"]["street"];
      },
    },
    _Tambon: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_tambon"];
      },
    },
    _Amphoe: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_amphoe"];
      },
    },
    _Province: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_province"];
      },
    },
    _Zipcode: {
      get() {
        return this.getter_dataBusiness_profile["address"]["zipcode_zipcode"];
      },
    },
  },
};
</script>
<style scoped>
#page_1 {
  background: #f5f5f5;
  border: 1px solid black;
  border-radius: 10px;
  width: 100%;
  cursor: default;
}
/*#page_1:hover {
  opacity: 0.8;
  background: #eeeeee;
  border: 1px solid transparent !important;
}*/
#page_2 {
  background: #f5f5f5;
  border: 1px solid black;
  border-radius: 10px;
  width: 100%;
  cursor: default;
  margin-top: 20px;
}
#page_2 .btn_select {
  font-size: 12px;
  color: #2196f3;
  font-weight: bold;
  text-align: end;
  cursor: pointer;
  height: 23px;
}
#page_2 .btn_select:hover {
  text-align: end;
  cursor: pointer;
}
#page_2:hover {
  color: #ffffff;
  background: linear-gradient(60deg, #30c3ea, #609cd4);
  border: 1px solid transparent !important;
}
.progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90vh;
  overflow: hidden;
}
.cardBranch {
  overflow: auto !important;
  height: 500px;
  margin-top: 15px;
}
</style>